import { render, staticRenderFns } from "./Measurement.vue?vue&type=template&id=13d0f582&scoped=true&"
import script from "./Measurement.vue?vue&type=script&lang=js&"
export * from "./Measurement.vue?vue&type=script&lang=js&"
import style0 from "./Measurement.vue?vue&type=style&index=0&id=13d0f582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d0f582",
  null
  
)

export default component.exports